module.exports = __webpack_public_path__ + "img/hat05_uv_sleeve_up.b8a7709a.svg";